<div class="host-container" *ngIf="enableMoreConditions">
  <span class="font-medium fs-08" *ngIf="operationsFormArray.controls.length - 1 !== index">OR</span>
  <button
    *ngIf="operationsFormArray.controls.length - 1 === index"
    mat-button
    color="primary"
    type="button"
    class="condition-btn"
    data-test="button-add-operation"
    (click)="addOperation()"
  >
    + Condition
  </button>
</div>
